


<app-header></app-header>
<section style="margin-top:100px;">

<section class="hero">
    <h1>Learn Crypto for Free With CredBull Exchange</h1>
    <div class="rotating-text">
    </div>
    <div class="hero-buttons">
      <a href="/learn">Start Learning</a>
      <a href="https://www.youtube.com/@Credbull_Exchange">Watch Videos</a>
    </div>
  </section>
<div class="video-modules">
  <h2>Video Modules</h2>
  <div class="video-grid">
    <div class="video-card" *ngFor="let item of List">
      <a [href]="item.url" class="card-link" target="_blank" rel="noopener noreferrer">
        <img [src]="path + 'slider/' + item.image" [alt]="item.title">
        <div class="play-btn">&#9658;</div>
        <h3>{{ item.title }}</h3>
        <p [innerHTML]="item.description"> </p>
      </a>
    </div>
  </div>
</div>


<section style="margin-top:320px;">
    <app-footer></app-footer>
</section>
